import {AxiosPromise} from 'axios';
import buildURL from 'axios/lib/helpers/buildURL';

import {ReservationsResponse} from 'models/Reservations';
import MercuryAPI from 'services/api/mercury';

export interface GetReservationsConfig {
  responseformat?: 'json' | 'xml';
  primaryaccttoken: string;
}

export const getReservations = (
  config: GetReservationsConfig
): AxiosPromise<ReservationsResponse> => {
  const params = {
    responseformat: 'json',
    ...config,
  };

  return MercuryAPI.runMercuryAPIRequest({
    // Encode the params directly using the axios buildURL, passing as params does not work as it will serialize the first param with '&' since it finds the '?' from our proxy redirect.
    url: buildURL('GetTRReservations', params),
  });
};
